
import React from "react";

export default function JumboTron(props) {
  return (
    <section className="jumbotron"></section>
  );
}

